__turbopack_context__.v({
  "subtitle": "sQEKmG_subtitle",
  "title": "sQEKmG_title",
});
